import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, FileText, Settings2, ClipboardCheck } from "lucide-react";
import { PermissaoEnum } from "@workflow/types";

import { TopBarSection } from "@/components/shared/SecaoBarraSuperior";
import { withPermissionPage } from "@/components/hocs/WithPermissionPage";
import { FormShellSkeleton } from "@/components/campos-formulario/form-shell/FormShellSkeleton";
import {
  SavingProgressDialog,
  SavingStepConfig,
} from "@/components/campos-formulario/form-shell/SavingProgressDialog";
import { useComunicadoSistemaEditForm } from "@/hooks/comunicados/use-comunicado-sistema-edit-form";
import { ComunicadoSistemaForm } from "./components/ComunicadoSistemaForm";

const SAVING_STEPS: SavingStepConfig[] = [
  { id: "conteudo", label: "Salvando o conteúdo", icon: <FileText className="size-4" /> },
  { id: "config", label: "Aplicando a configuração", icon: <Settings2 className="size-4" /> },
  { id: "finalizando", label: "Finalizando", icon: <ClipboardCheck className="size-4" /> },
];

const ComunicadoSistemaEditPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const controller = useComunicadoSistemaEditForm(Number(id));

  return (
    <div className="space-y-2">
      <TopBarSection
        title="Editar comunicado"
        showButton
        buttonLabel="Voltar"
        buttonIcon={<ArrowLeft />}
        onButtonClick={() => navigate("/admin/comunicados")}
      />

      {controller.isLoading ? (
        <FormShellSkeleton variant="wizard" />
      ) : (
        <ComunicadoSistemaForm controller={controller} />
      )}

      <SavingProgressDialog
        open={controller.savingOpen}
        status={controller.savingStatus}
        steps={SAVING_STEPS}
        title="Salvando comunicado"
        description={
          controller.publicou
            ? "Estamos salvando e publicando o comunicado."
            : "Estamos salvando as alterações."
        }
        successTitle={controller.publicou ? "Comunicado publicado!" : "Comunicado salvo!"}
        successDescription={
          controller.publicou
            ? "Já está no ar para o público-alvo (ou agendado, se o início for no futuro)."
            : "Alterações aplicadas."
        }
        errorTitle="Não foi possível salvar"
        errorDescription="Algo deu errado. Tente novamente."
        errorActionLabel="Tentar de novo"
        onComplete={controller.handleSavingComplete}
        onClose={controller.handleSavingErrorClose}
      />
    </div>
  );
};

export default withPermissionPage(ComunicadoSistemaEditPage, [
  PermissaoEnum.COMUNICADO_SISTEMA_MANAGE,
]);
